import {NumberButton} from "@FRAMEWORK/ui/desktop/button";
import styled from "styled-components";

const CountingWrap = styled.div`
	display: flex;
	button {
		width: 32px;
		height: 32px;
		border: 1px solid var(--border-color);

		&:before {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&:after {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&:first-of-type {
			border-radius: 4px 0 0 4px;
			&:before {
				width: 12px;
				border-radius: 2px;
			}
			&:disabled {
				&:before {
					background-color: #9a9a9a;
				}
			}
		}

		&:last-of-type {
			border-radius: 0 4px 4px 0;
			&:before {
				height: 12px;
				border-radius: 2px;
			}
			&:after {
				width: 12px;
				border-radius: 2px;
			}
			&:disabled {
				&::before,
				&::after {
					background-color: #9a9a9a;
				}
			}
		}
	}
`;

const NumberInput = styled.input<{$isMinValue?: boolean}>`
	width: 40px;
	height: 32px;
	padding: 10px 5px;
	font-size: 15px;
	border-color: var(--border-color);
	border-left: 0;
	border-right: 0;
	text-align: center;
	color: ${({$isMinValue}) => ($isMinValue ? "var(--placeholder-color)" : "var(--sub-title-color)")};
	font-family: "PT-semibold";
`;

interface IProps {
	value: number;
	minValue?: number;
	increase?: (number: number) => void;
	decrease?: (number: number) => void;
	onClick?: (trigger: string, number: number) => void;
}

const CountingButton = ({increase, decrease, onClick, value, minValue = 0}: IProps) => {
	const maxValue = 30;

	const onIncrease = () => {
		const increaseNumber = value + 1;
		typeof increase === "function" && increase(increaseNumber);
		typeof onClick === "function" && onClick("plus", increaseNumber);
	};

	const onDecrease = () => {
		const decreasedNumber = Math.max(value - 1, 0);
		typeof decrease === "function" && decrease(decreasedNumber);
		typeof onClick === "function" && onClick("minus", decreasedNumber);
	};

	return (
		<CountingWrap>
			<NumberButton types="minus" onClick={onDecrease} disabled={value <= minValue}></NumberButton>
			<NumberInput width="38px" value={value} readOnly />
			<NumberButton types="plus" onClick={onIncrease} disabled={value >= maxValue}></NumberButton>
		</CountingWrap>
	);
};

export default CountingButton;
export {CountingWrap};
